import { cn } from "../../../../utils/cn";

interface Props {
  title: string;
  count: number;
  variant: "total" | "completed" | "flagged" | "unanswered";
  setFocusTyped: (
    val: null | "total" | "completed" | "flagged" | "unanswered"
  ) => void;
}
const ModalCounterBlock = ({ title, count, variant, setFocusTyped }: Props) => {
  return (
    <div
      onMouseOver={() => {
        if (variant !== "total") {
          setFocusTyped(variant);
        }
      }}
      onMouseOut={() => {
        setFocusTyped(null);
      }}
      className={cn(
        "w-[250px] border rounded-xl p-3  space-y-2",
        variant === "total" && "bg-bkg border-border",
        variant === "completed" && "bg-[#F0FDF4] border-[#00875D]/25",
        variant === "flagged" && "bg-[#FDF1D0] border-[#ead9a8]",
        variant === "unanswered" && "bg-secondary/10 border-secondary/10"
      )}
    >
      <p
        className={cn(
          "text-base font-semibold leading-5 ",
          variant === "total" && "text-secondary/60",
          variant === "completed" && "text-[#00875D]",
          variant === "flagged" && "text-[#AA6207]",
          variant === "unanswered" && "text-secondary/50"
        )}
      >
        {title}
      </p>
      <h2
        className={cn(
          "text-4xl font-semibold leading-10 ",
          variant === "total" && "text-secondary",
          variant === "completed" && "text-[#00875D]",
          variant === "flagged" && "text-[#AA6207]",
          variant === "unanswered" && "text-secondary/50"
        )}
      >
        {count}
      </h2>
    </div>
  );
};

export default ModalCounterBlock;
